import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import Cart from "@/components/cart/Cart";

// interface CartProps {}

// const Cart: React.FC<CartProps> = () => {
const CartPage: React.FC = () => {
  return (
    <SpaceBetween size="xl">
      <Header
        variant="h1"
        description="Your selected group of clips to add to Iconik."
      >
        Cart
      </Header>
      <Cart />
    </SpaceBetween>
  );
};

export default CartPage;
